import React from "react"
import { css } from "styled-components"
import Button from "../../design-system/atoms/button"
import Text from "../../design-system/atoms/text"
import VariantContainer, {
  IStyleVariant,
} from "../../design-system/atoms/variant-container"
import mergeVariants from "../../design-system/util/merge-variants"
import FadedTitle from "../shared/faded-title"
import withAnimation, {
  FadeIn,
  FadeInBottom,
} from "../../design-system/util/withAnimation"
const AnimatedVariantContainer = withAnimation(VariantContainer)

interface IProjectDescription {
  fadeSettings: object
  fadeImage: string
  fadeTitle: string
  fadeAlt: string
  containerVariants?: IStyleVariant | any[]
  textVariants?: IStyleVariant | any[]
  showDivider?: boolean
  buttonHref: string
  description: JSX.Element
  children?: React.ReactNode
}

export default function ProjectDescription({
  fadeSettings,
  fadeImage,
  fadeTitle,
  fadeAlt,
  children,
  containerVariants,
  textVariants,
  showDivider = true,
  buttonHref,
  description,
}: IProjectDescription) {
  return (
    <>
      <VariantContainer
        variants={mergeVariants(
          [
            css`
              flex: 1 1 40%;

              align-self: center;

              display: flex;
              flex-direction: column;
              align-items: center;
              margin-top: 32px;
            `,
            css`
              margin-top: 48px;
            `,
            css`
              align-items: flex-start;
              margin: 0;
            `,
          ],
          containerVariants
        )}
      >
        <AnimatedVariantContainer animation={FadeIn}>
          <FadedTitle
            fadeSettings={fadeSettings}
            image={fadeImage}
            title={fadeTitle}
            alt={fadeAlt}
            textAlign={{ sm: "center", md: "center", lg: "left" }}
          />
        </AnimatedVariantContainer>
        {/* Divider Line */}
        {showDivider && (
          <AnimatedVariantContainer
            animation={FadeIn}
            variants={[
              css`
                max-width: 480px;
                border-top: 1px solid var(--dark-mode-heading);
                margin-top: 24px;
                width: 66.6vw;
              `,
              null,
              css`
                max-width: 537px;
                width: 40vw;
              `,
            ]}
          />
        )}
        <VariantContainer
          variants={[
            css`
              color: var(--body-text-grey);
              display: flex;
              flex-direction: column;
              align-items: center;
              text-align: center;
            `,
            null,
            css`
              align-items: flex-start;
              text-align: left;
            `,
          ]}
        >
          <AnimatedVariantContainer
            animation={FadeInBottom}
            variants={[
              css`
                width: 100%;
              `,
            ]}
          >
            {children}
          </AnimatedVariantContainer>
          <AnimatedVariantContainer animation={FadeInBottom}>
            <Text.Body
              variants={mergeVariants(
                [
                  css`
                    padding: 48px 0 32px 0;
                    font-weight: 300;
                    & > span {
                      font-weight: 500;
                    }
                  `,
                  css`
                    padding: 32px 0 48px 0;
                    font-weight: 300;
                  `,
                  css`
                    font-weight: 300;
                  `,
                ],
                textVariants
              )}
            >
              {description}
            </Text.Body>
          </AnimatedVariantContainer>
          <AnimatedVariantContainer
            animation={FadeInBottom}
            variants={[
              css`
                max-width: 282px;
                width: 282px;
                display: flex;
                flex-wrap: wrap;
                align-self: center;
              `,
              null,
              css`
                align-self: flex-start;
              `,
            ]}
          >
            <Button.Link to={buttonHref} target="_blank">
              Learn More
            </Button.Link>
          </AnimatedVariantContainer>
        </VariantContainer>
      </VariantContainer>
    </>
  )
}
